export const TourDurationFilter = ['3-7 Days', '7-11 Days', '11-15 Days', 'Above 15 Days'];

export const AdventuresFilter = [
  'Beach',
  'Surfing',
  'Sailing',
  'Hiking & Trekking',
  'Desert',
  'Hill Stations',
  'River Cruise'
];

//Sort By Filter Optiops for Package-listing screen
export const SortByFilterArray = ['New Packages', 'Popular'];
